import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const SUPPORTED_LANGUAGES = ['ru', 'en', 'es', 'et'];
const DEFAULT_LANGUAGE = 'ru';

export const useLanguageFromQuery = () => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const languageFromQuery = searchParams.get('language');
    
    const targetLanguage = 
      languageFromQuery && SUPPORTED_LANGUAGES.includes(languageFromQuery)
        ? languageFromQuery
        : DEFAULT_LANGUAGE;

    if (i18n.language !== targetLanguage) {
      i18n.changeLanguage(targetLanguage);
    }
  }, [searchParams, i18n]);
};
